// import React from 'react'

// import { DynamicField } from './DynamicField'
// import { DoubleColContainer, FieldRow, Form } from './style'
// import { PlainCard } from '../..'
// import { useChallenge } from '../../../context'

// const ChallengeForm = () => {
//   const { formActions, formState } = useChallenge()
//   const { fields, ...actions } = formActions

//   return (
//     <Form>
//       {fields.map((field) => (
//         <PlainCard
//           key={field.title}
//           title={field.title}
//           className={field.className}
//         >
//           <FieldRow style={{ display: 'flex' }}>
//             {field.rowRight && (
//               <FieldRow>
//                 {field.rowRight.map((item, index) => {
//                   const nextItem = field.rowRight && field.rowRight[index + 1]

//                   if (item.id === 'startDate') {
//                     return (
//                       <DoubleColContainer key={`dates-${item.id}`}>
//                         <DynamicField
//                           item={item}
//                           stateFn={actions}
//                           refId={formState.id}
//                         />

//                         {nextItem?.id === 'endDate' && (
//                           <DynamicField
//                             item={nextItem}
//                             stateFn={actions}
//                             refId={formState.id}
//                           />
//                         )}
//                       </DoubleColContainer>
//                     )
//                   }

//                   if (item.id === 'category') {
//                     return (
//                       <DoubleColContainer key={`states-${item.id}`}>
//                         <DynamicField
//                           item={item}
//                           stateFn={actions}
//                           className="col-md"
//                           refId={formState.id}
//                         />

//                         {nextItem?.id === 'visibility' && (
//                           <DynamicField
//                             item={nextItem}
//                             stateFn={actions}
//                             className="col-md"
//                             refId={formState.id}
//                           />
//                         )}
//                       </DoubleColContainer>
//                     )
//                   }

//                   // Si es endDate, ya lo renderizamos arriba → no lo repetimos
//                   if (item.id === 'endDate' || item.id === 'visibility')
//                     return null

//                   // Render normal para todos los demás campos
//                   return (
//                     <DynamicField
//                       item={item}
//                       stateFn={actions}
//                       refId={formState.id}
//                     />
//                   )
//                 })}
//               </FieldRow>
//             )}

//             {field.rowLeft && (
//               <FieldRow>
//                 {field.rowLeft.map((item) => (
//                   <DynamicField
//                     item={item}
//                     stateFn={actions}
//                     refId={formState.id}
//                     key={item.id}
//                   />
//                 ))}
//               </FieldRow>
//             )}
//           </FieldRow>
//         </PlainCard>
//       ))}
//     </Form>
//   )
// }

// export default ChallengeForm
import React, { useMemo } from 'react'

import { DynamicField } from './DynamicField'
import { DoubleColContainer, FieldRow, Form } from './style'
import { PlainCard } from '../..'
import { useChallenge } from '../../../context'
import { FormFieldItem } from '../../../types'

type RowGroup =
  | { type: 'pair'; key: string; left: FormFieldItem; right: FormFieldItem }
  | { type: 'single'; key: string; item: FormFieldItem }

const pairConfig = [
  { leftId: 'startDate', rightId: 'endDate', key: 'dates' },
  { leftId: 'category', rightId: 'visibility', key: 'meta' },
] as const

const buildRowGroups = (items: FormFieldItem[]): RowGroup[] => {
  const groups: RowGroup[] = []
  const skip = new Set<number>()

  for (let i = 0; i < items.length; i++) {
    if (skip.has(i)) continue

    const item = items[i]
    const next = items[i + 1]

    const pair = pairConfig.find(
      (p) => p.leftId === item.id && next?.id === p.rightId,
    )

    if (pair && next) {
      groups.push({
        type: 'pair',
        key: `${pair.key}-${item.id}`,
        left: item,
        right: next,
      })
      skip.add(i + 1)
      continue
    }

    groups.push({ type: 'single', key: item.id, item })
  }

  return groups
}

const ChallengeForm = () => {
  const { formActions, formState } = useChallenge()
  const { fields, ...actions } = formActions

  return (
    <Form>
      {fields.map((field) => {
        const rightGroups = useMemo(
          () => (field.rowRight ? buildRowGroups(field.rowRight) : []),
          [field.rowRight],
        )

        return (
          <PlainCard
            key={field.title}
            title={field.title}
            className={field.className}
          >
            <FieldRow style={{ display: 'flex' }}>
              {/* RIGHT */}
              {field.rowRight && (
                <FieldRow>
                  {rightGroups.map((g) => {
                    if (g.type === 'pair') {
                      const isMetaPair = g.left.id === 'category'

                      return (
                        <DoubleColContainer key={g.key}>
                          <DynamicField
                            item={g.left}
                            stateFn={actions}
                            refId={formState.id}
                            className={isMetaPair ? 'col-md' : undefined}
                          />
                          <DynamicField
                            item={g.right}
                            stateFn={actions}
                            refId={formState.id}
                            className={isMetaPair ? 'col-md' : undefined}
                          />
                        </DoubleColContainer>
                      )
                    }

                    return (
                      <DynamicField
                        key={g.key}
                        item={g.item}
                        stateFn={actions}
                        refId={formState.id}
                      />
                    )
                  })}
                </FieldRow>
              )}

              {/* LEFT */}
              {field.rowLeft && (
                <FieldRow>
                  {field.rowLeft.map((item) => (
                    <DynamicField
                      key={item.id}
                      item={item}
                      stateFn={actions}
                      refId={formState.id}
                    />
                  ))}
                </FieldRow>
              )}
            </FieldRow>
          </PlainCard>
        )
      })}
    </Form>
  )
}

export default ChallengeForm
